module.exports = __webpack_public_path__ + "img/plb5.9dcced1e.png";